import {
  GETTRANSACTIONTYPELIST_SUCCESS,
  GETTRANSACTIONTYPELIST_FAILED,
  RESET_GETTRANSACTIONTYPELIST,
  LOADING_GETTRANSACTIONTYPELIST,
  NETWORK_ERROR_GETTRANSACTIONTYPELIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetTransactionTypeList = () => {
  return { type: RESET_GETTRANSACTIONTYPELIST };
};

const getTransactionTypeListDetails =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETTRANSACTIONTYPELIST });
    await partnerServices
      .post("getTransactionTypeList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(getTransactionTypeListSuccess(res.data));
            break;
          default:
            dispatch(getTransactionTypeListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETTRANSACTIONTYPELIST,
          payload: err,
        });
      });
  };
function getTransactionTypeListSuccess(data) {
  return {
    type: GETTRANSACTIONTYPELIST_SUCCESS,
    payload: data,
  };
}
function getTransactionTypeListFailed(data) {
  return {
    type: GETTRANSACTIONTYPELIST_FAILED,
    payload: data,
  };
}

export { resetGetTransactionTypeList, getTransactionTypeListDetails };
